import { Col, Row } from 'react-bootstrap'

export const CenteredContentLayout = ({ children }) => (
  <Row className="justify-content-center">
    <Col xxl="8" xl="10" lg="12">
      {children}
    </Col>
  </Row>
)
